import { getLocale } from "../runtime";

const sv_escountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Spain`
};

const escountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_escountryenglish(inputs)
	return "esCountryEnglish";
};

export { escountryenglish as "esCountryEnglish" };